/**
 * Created by kldavis on 2/23/17.
 */
var OCS = OCS || {};
OCS.Classes = OCS.Classes || {};
OCS.Classes.DynamicScriptLoaderJobMngr = new Class({
    Implements: [Options, Events, new Class(OCS.Interfaces.UniqueId)],
    debug: false,
    job_series: {},
    active_job_series: [],
    requested_scripts: [],
    finished_loaded_scripts: [],
    remove_completed_jobs_timeout_id: null,
    options: {
        time_between_job_cleanup: 15 * 60 * 1000 // 15 minutes
    },
    initialize: function (op) {
        this.setOptions(op);
    },
    script_url_to_script_id: {},
    create_job_series: function (load_spec) {
        var series = new OCS.Classes.DynamicScriptLoaderJobSeries(load_spec);
        series.addEvent('script_loaded', this.on_script_loaded.bind(this));
        series.run.delay(1, series);
        return series;
    },
    is_script_requested: function (script_url) {
        return this.requested_scripts.indexOf(script_url) >= 0;
    },
    script_is_requested: function (script_url) {
        this.requested_scripts.push(script_url);
    },
    is_script_finished_loaded: function (script_url) {
        return this.finished_loaded_scripts.indexOf(script_url) >= 0;
    },
    script_is_finished_loaded: function (script_url) {
        this.finished_loaded_scripts.push(script_url);
    },
    on_script_loaded: function (event) {
        var script_url = event.url;
        var dom_element = event.element;

        // Register that we have the script completed
        this.script_is_finished_loaded(script_url);
    },
    remove_script: function (script_url) {
        var script_id = this.script_url_to_script_id[script_url];
        if (script_id) {
            var elements = document.getElementsByClassName(script_id);
            while (elements[0]) {
                elements[0].parentNode.removeChild(elements[0]);
            }
        }
        this.requested_scripts.erase(script_url);
        this.finished_loaded_scripts.erase(script_url);
    },
    set_debug: function (val) {
        this.debug = val;
        if (typeof this.jobs !== "undefined") {
            Object.each(this.jobs, function (job) {
                job.set_debug(val);
            });
        }
    }
});